import { render, staticRenderFns } from "./LocataireArchive.vue?vue&type=template&id=1ee0b1b0&"
import script from "./LocataireArchive.vue?vue&type=script&lang=ts&"
export * from "./LocataireArchive.vue?vue&type=script&lang=ts&"
import style0 from "./LocataireArchive.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports